import { Route } from 'react-router-dom'
import { PaymentStaticRoutes } from './PaymentRoutes'
import { bottomSheetPageRoutes } from '../bottom-sheet-pages/routes'
import Stopwatch from '../components/Questionnaire/stopwatch/Stopwatch'
import RiskProfileResultPage from '../pages/RiskProfileResultPage'
import { RebalancePlanISINPage } from '../pages/RebalancePlan/RebalancePlanISIN'
import RiskQuestionnaire from '../components/Questionnaire/RiskQuestionnaire'
import { RebalancePlanSummaryPage } from '../pages/RebalancePlan/RebalancePlanSummaryPage'

// Direct imports for static pages
import ESignPage from '../pages/ESignPage'
import DGAadhaarPage from '../pages/DGAadhaarPage'
import { PowerOfRebalancingPage } from '../pages/PowerOfRebalancingPage'
import Explore from '../pages/Explore'
import { FDFTUXHomePage } from '../pages/FD/FDFTUXHomePage'
import { FDFTUXPage } from '../pages/FD/FDFTUXPage'
import { FDBestPlanPage } from '../pages/FD/FDBestPlanPage'
import { PowerRebalancePage } from '../pages/PowerRebalancePage'
import KnowWhyPage from '../pages/KnowWhyPage'
import { EliteLandingPageV7 } from '../pages/elite-landing-pages/EliteLandingPageV7'
import PeerAnalyserPage from '../pages/peer-analyser/PeerAnalyserPage'
import BrowseCategoriesPage from '../pages/peer-analyser/BrowseCategoriesPage'
import { PageWithDoc } from '../pages/PageWithDoc'
import { EliteLandingPageV5 } from '../pages/elite-landing-pages/EliteLandingPageV5'
import { EliteLandingPageRB } from '../pages/elite-landing-pages/EliteLandingPageRB'
import { EliteDashboardPage } from '../pages/EliteDashboardPage'
import { EliteFamilyLandingPage } from '../pages/elite-landing-pages/family/EliteFamilyLandingPage'
import { RebalanceQuestionnaireOTPPage } from '../pages/RebalanceQuestionnaireOTPPage'
import { WrappedRivePage } from '../pages/Wrapped'
import { EliteWrappedRivePage } from '../pages/EliteWrapped'
import { EliteLandingPageRBWithTimer } from '../pages/elite-landing-pages/EliteLandingPageRBWithTimer'
import { EliteLandingPageRBTimer } from '../pages/elite-landing-pages/EliteLandingPageRBTimer'
import RegularToDirectPlanPage from '../pages/regular-to-direct-plan-page/RegularToDirectPlanPage'
import RegularToDirectPlanElitePage from '../pages/regular-to-direct-plan-page/RegularToDirectPlanElitePage'
import RegularToDirectPlanL2Page from '../pages/regular-to-direct-plan-page/RegularToDirectPlanL2Page'
import { BrokeLandingPage } from '../pages/elite-landing-pages/BrokeLandingPage'
import { TaxHarvestingRoutes } from '../features/tax-harvesting/TaxHarvestingRoutes'
import { MFCRedirectionRoutes } from '../features/mfc-redirection/MFCRedirectionRoutes'
import { editableAmountsSheetRoute } from '../pages/EditableAmountsSheetPage'
import { StackDemoRoutes } from '../stack-navigation/demo/StackDemoRoutes'
import NewEliteLandingPage from '../features/new-elite-landing/pages/NewEliteLandingPage'
import NewEliteDashboardPage from '../features/new-elite-landing/pages/NewEliteDashboardPage'
import NewEliteFamilyLandingPage from '../features/new-elite-landing/pages/family/NewEliteFamilyLandingPage'
import NewEliteFamilyDashboardPage from '../features/new-elite-landing/pages/family/NewEliteFamilyDashboardPage'
import ElitePlansLandingPage from '../features/elite-plans-landing/pages/ElitePlansLandingPage'
import ElitePlansMemberPage from '../features/elite-plans-landing/pages/ElitePlansMemberPage'
import ElitePlansFamilyLandingPage from '../features/elite-plans-landing/pages/ElitePlansFamilyLandingPage'
import ElitePlansFamilyMemberPage from '../features/elite-plans-landing/pages/ElitePlansFamilyMemberPage'
import ElitePlansEliteLandingPage from '../features/elite-plans-landing/pages/ElitePlansEliteLandingPage'
import ElitePlansEliteDashboardPage from '../features/elite-plans-landing/pages/ElitePlansEliteDashboardPage'
import ElitePlansEliteFamilyLandingPage from '../features/elite-plans-landing/pages/ElitePlansEliteFamilyLandingPage'
import ElitePlansEliteFamilyDashboardPage from '../features/elite-plans-landing/pages/ElitePlansEliteFamilyDashboardPage'
import ElitePrimeLandingPage from '../features/elite-plans-landing/pages/ElitePrimeLandingPage'
import ElitePrimeDashboardPage from '../features/elite-plans-landing/pages/ElitePrimeDashboardPage'
import ElitePrimeFamilyLandingPage from '../features/elite-plans-landing/pages/ElitePrimeFamilyLandingPage'
import ElitePrimeFamilyDashboardPage from '../features/elite-plans-landing/pages/ElitePrimeFamilyDashboardPage'
import { InfiniteLandingRoutes } from './InfiniteLandingRoutes'
import { PpfasGiftFundLandingPage } from '../features/ppfas-handling/landing-page/PpfasGiftFundLandingPage'

export const StaticRoutes = () => {
  return [
    <Route path='/health' element={<h3>Healthy App</h3>} />,
    <Route path='/esign' element={<ESignPage />} />,
    <Route path='/digilocker-response' element={<DGAadhaarPage />} />,
    <Route path='/power-of-rebalancing' element={<PowerOfRebalancingPage />} />,
    <Route path='/explore' element={<Explore />} />,
    <Route path='/elite-dashboard' element={<EliteDashboardPage />} />,
    <Route path='/elite/rb-timer' element={<EliteLandingPageRBWithTimer />} />,
    <Route path='/elite/rebalancing-timer' element={<EliteLandingPageRBTimer />} />,
    <Route path='/elite/v5' element={<EliteLandingPageV7 />} />,
    <Route path='/elite/v4' element={<EliteLandingPageRB />} />,
    <Route path='/elite/v3' element={<EliteLandingPageV7 />} />,
    <Route path='/elite/rb' element={<EliteLandingPageV5 />} />,
    <Route path='/elite/v2' element={<EliteLandingPageRB />} />,
    <Route path='/broke-landing-page' element={<BrokeLandingPage />} />,
    <Route path='/elite' element={<EliteLandingPageV7 />} />,
    // <Route path='/elite-x-fd' element={<EliteXFDPage />} />,
    <Route path='/elite/family' element={<EliteFamilyLandingPage />} />,
    <Route path='/fd-ftux-home' element={<FDFTUXHomePage />} />,
    <Route path='/fd-ftux/:ftuxType' element={<FDFTUXPage />} />,
    <Route path='/fd-best-plan/:planId' element={<FDBestPlanPage />} />,
    <Route path='/smart-rebalance' element={<PowerRebalancePage />} />,
    <Route path='/peer-analyser' element={<PeerAnalyserPage />} />,
    <Route path='/browse-categories' element={<BrowseCategoriesPage />} />,
    <Route path='/know-why/:isin' element={<KnowWhyPage />} />,
    <Route path='/rebalance-questionnaire-otp' element={<RebalanceQuestionnaireOTPPage />} />,
    <Route path='/rebalance-questionnaire' element={<RiskQuestionnaire />} />,
    <Route path='/risk-profile-result' element={<RiskProfileResultPage />} />,
    <Route path='/stopwatch' element={<Stopwatch />} />,
    <Route path='/rebalance-plan' element={<RebalancePlanSummaryPage />} />,
    <Route path='/rebalance-plan/:isin' element={<RebalancePlanISINPage />} />,
    <Route path='/document' element={<PageWithDoc />} />,
    <Route path='/wrapped' element={<WrappedRivePage />} />,
    <Route path='/elite-wrapped' element={<EliteWrappedRivePage />} />,
    <Route path='/regular-to-direct-plan' element={<RegularToDirectPlanPage />} />,
    <Route path='/regular-to-direct-plan-elite' element={<RegularToDirectPlanElitePage />} />,
    <Route path='/regular-to-direct-plan-elite/:isin' element={<RegularToDirectPlanL2Page />} />,
    ...StackDemoRoutes(),
    <Route path='/new-elite-landing' element={<NewEliteLandingPage />} />,
    <Route path='/new-elite-dashboard' element={<NewEliteDashboardPage />} />,
    <Route path='/new-elite-family-landing' element={<NewEliteFamilyLandingPage />} />,
    <Route path='/new-elite-family-dashboard' element={<NewEliteFamilyDashboardPage />} />,

    // Elite Plans — see also `features/elite-plans-landing/constants/routes.ts`.
    // Dual-tab (Elite ↔ Prime): sell vs member. Elite-only / Prime-only: locked tab.
    // `from=HOME` hides the webview header (safe-area pad only).
    <Route path='/elite-plans' element={<ElitePlansLandingPage />} />, // sell, both tabs
    <Route path='/elite-plans-member' element={<ElitePlansMemberPage />} />, // Elite dashboard + Prime sell
    <Route path='/elite-landing' element={<ElitePlansEliteLandingPage />} />, // sell, Elite locked
    <Route path='/elite-member-dashboard' element={<ElitePlansEliteDashboardPage />} />, // member, Elite locked
    <Route path='/elite-prime-landing' element={<ElitePrimeLandingPage />} />, // sell, Prime locked
    <Route path='/elite-prime-dashboard' element={<ElitePrimeDashboardPage />} />, // member, Prime locked
    <Route path='/elite-plans-family-landing' element={<ElitePlansFamilyLandingPage />} />,
    <Route path='/elite-plans-family-member' element={<ElitePlansFamilyMemberPage />} />,
    <Route path='/elite-family-landing' element={<ElitePlansEliteFamilyLandingPage />} />,
    <Route path='/elite-family-dashboard' element={<ElitePlansEliteFamilyDashboardPage />} />,
    <Route path='/elite-prime-family-landing' element={<ElitePrimeFamilyLandingPage />} />,
    <Route path='/elite-prime-family-dashboard' element={<ElitePrimeFamilyDashboardPage />} />,
    <Route path='/ppfas-gift-fund' element={<PpfasGiftFundLandingPage />} />,

    ...InfiniteLandingRoutes(),
    ...bottomSheetPageRoutes(),
    editableAmountsSheetRoute(),
    ...TaxHarvestingRoutes(),
    ...PaymentStaticRoutes(),
    ...MFCRedirectionRoutes()
  ]
}
